import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {TopBarButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/TopBarButton';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FlowTopBarAddButton.less');
const cx = classnames.bind(styles);

@observer
export class FlowTopBarAddButton extends React.Component<any, any>
{
    private _topBarButton:HTMLInputElement | null;

    private _refHandlers = {
        topBarButton: (ref:HTMLInputElement | null) =>
        {
            this._topBarButton = ref;
        }
    };

    public componentDidMount()
    {
        document.addEventListener('mousedown', this._handleClick, false);
    }

    public componentWillUnmount()
    {
        document.removeEventListener('mousedown', this._handleClick, false);
    }

    private _handleClick = (event:MouseEvent) =>
    {
        const {flowTopBar} = controllers.ui;

        if( !this._topBarButton )
        {
            return;
        }

        if( this._topBarButton.contains(event.target as any) )
        {
            flowTopBar.toggleWonderBarVisibility();
        }
        else
        {
            this._handleClickOutside(event);
        }
    };

    private _handleClickOutside = (event:MouseEvent) =>
    {
        const {flowTopBar} = controllers.ui;
        const wonderBarDomRef = flowTopBar.getWonderBarDomRef();

        if( !wonderBarDomRef )
        {
            return;
        }

        if( !wonderBarDomRef.contains(event.target as any) && flowTopBar.isWonderBarVisible() )
        {
            flowTopBar.setWonderBarVisibility(false);
        }
    };

    public render():JSX.Element
    {
        const {flowTopBar} = controllers.ui;

        return (
            <TopBarButton
                onRef={this._refHandlers.topBarButton}
                className={cx('base')}
                iconProps={{name: WSPIcons.visualDesigner.topBar.Plus}}
                text={'Add Blocks'}
                isToggledOn={flowTopBar.isWonderBarVisible()}
            />
        );
    }
}

